import(/* webpackMode: "eager" */ "/codebuild/output/src2581901366/src/skop-manage/node_modules/next/dist/client/app-dir/link.js");
